import React from 'react'

export default function SummaryCard({ icon: Icon, title, action, children }) {
  return (
    <div className="w-full bg-white rounded-2xl border border-border-lines shadow-sm p-6">
      <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
        <div className="flex items-center gap-4">
          <Icon className="text-secondary" size={24} />
          <h2 className="text-xl font-semibold text-secondary">{title}</h2>
        </div>

        {action}
      </div>

      {children}
    </div>
  )
}
